import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bea405e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bea405e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bea405e')) {
      api.createRecord('6bea405e', component.options)
    } else {
      api.reload('6bea405e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bea405e&scoped=true&", function () {
      api.rerender('6bea405e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/finance/staCheFang/index.vue"
export default component.exports